import { PDMenuItem } from './menu.type';
import ModuleIcon from '@/icons/modules';

export const defaultMenuRaw: PDMenuItem[] = [
  {
    name: 'Modules',
    icon: <ModuleIcon />,
    permission: true,
    path: '/modules',
  },
];
